
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const AuthDialog = ({ open, onOpenChange }: AuthDialogProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Maak een gratis account aan</DialogTitle>
          <DialogDescription>
            Wil je je werk niet kwijtraken? Maak gratis een account aan en bewaar je lesplannen!
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <Button onClick={() => navigate('/login')}>
            Inloggen
          </Button>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
